import React, {useEffect} from 'react';
import Stylesheet from './Cell.module.css';
import File from '../File/File';
import Refference from '../Refference/Refference';
import {firestore} from '@enigma/core/services';
import { ico_check } from '../../../../icon';
import { useLocation } from 'react-router-dom';
import Classnames from 'classnames';
import Input from '../../../../elements/Input/Input';
import DateCell from '../Date/Date';
import Heading from '../../../../elements/Heading/Heading';
import Number from '../../../../elements/Number/Number';
import { updateRecord } from '../../Table.Engine';

const Cell = (props) => {
    const location = useLocation();
    const record = props.metadata;
    const column = props.column;
    const tableMetadata = props.table;
    const tableConfig = props.config;
    const appContext = props.appContext;
    // TEMP CODE REMOVE AFTER RECORDS HAVE BEEN FILLED
    useEffect(() => {
        if (column.type === "notify" && record[column.name]) {
            const payload = {
                branch: record.branch,
                due: record[column.name],
                table: tableMetadata.name,
                column: column.title,
                url: `tables/${tableMetadata.name}?search=${record.id}`,
                type: 'notify',
                record: `${tableMetadata.collection}/${record.id}`
            }
            // add record
            firestore.doc(`notifications/${record.id}`).get()
            .then(snap => {
                if (!snap.exists)
                    firestore.doc(`notifications/${record.id}`).set(payload)
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const getSelectedColumns = _ => {
        const search = location.search;
        let selected = [];
        const columns = search.split('&').find((query) => 
        query.search('column=') > -1 ? true : false);
        if (columns) {
            const current = columns.split('column=')[1].split(',');
            if (current[0] === "") current.splice(0,1);
            for (const recordID of current) 
                selected.push({id: recordID})
        }
        return selected;
    }
    const isCellColumnSelected = _ => {
        const selected = getSelectedColumns();
        if (selected.findIndex(({id}) => id === column.name) > -1)
            return true;
        return false;
    }
    const value = _ => {
        switch (column.type) {
            case "primaryKey":
                return record.id;
            case "user":
                return record.author;
            case "timestamp":
                return new Date(record.timestamp).toDateString();
            case "date":
            case "notify":
                return new Date(record[column.name] || NaN).toDateString();
            case "number":
                return record[column.name] || 0;
            case "file":
                return record[column.name]?.name || column.default || "NAN";
            default:
                return record[column.name] || column.default || "NAN";
        }
    }
    const onChange = async (newValue, removed = false) => {
        if (value() === newValue) return;
        if (newValue === null || newValue === "") return;
        if (column?.unique) {
            // column value must not already exist
            // search device db for duplicates
        }
        // update notification for record
        if (column.type === "notify") {
            // add record
            firestore.doc(`notifications/${record.id}`)
            .update({ due: newValue })
        }
        // update record value
        if (removed) delete record[column.name];
        else record[column.name] = newValue;
        // update record document
        updateRecord(record.id, record, tableMetadata, tableConfig)
        .then(_ => appContext.toggleToast(ico_check, "record updated"))
    }
    const field = _ => {
        switch (column.type) {
            case "string":
                return <Input className={Stylesheet.Input}
                onBlur={value => onChange(value)}
                defaultValue={value()} />
            case "number":
                return <Number className={Stylesheet.Input}
                onBlur={value => onChange(value)}
                min={0}
                placeholder='enter a number'
                type="number" 
                defaultValue={value()} />
            case "date":
                return <DateCell className={Stylesheet.Input} 
                defaultValue={value()} onChange={onChange} />
            case "file":
                return <File defaultValue={value()} 
                table={tableMetadata} record={record}
                column={column} onChange={onChange} />
            case "table refference" || "form refference":
                return <Refference onChange={onChange}
                table={tableMetadata} record={record} config={tableConfig}
                defaultValue={value()} column={column} />
            case "notify":
                return <DateCell className={Stylesheet.Input} 
                defaultValue={value()} onChange={onChange} />
            default:
                break;
        }
    }
    const style = Classnames(Stylesheet.Container, {
    [Stylesheet['CellColumnSelected']]: isCellColumnSelected()})
    // only render custom cells
    if (column?.required) {
        // check if a record lock critera is set
        if (!tableConfig?.recordLock)
            return <div className={style}>{field()}</div>
        else {
            // check if record lock critera is met, if not render cell as non-editable
            if (record[tableConfig.recordLock.property] === tableConfig.recordLock.value)
                return <div className={style}>{field()}</div>
        }
    }
    return (
        <div className={style}>
            <Heading index={5} 
            onClick={_ => navigator.clipboard.writeText(value())}>
            {value()}</Heading>
        </div>
    )
}

export default Cell;